var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0536 18.0462C19.3319 18.3245 19.3319 18.7756 19.0536 19.0539C18.7754 19.3321 18.3242 19.3321 18.046 19.0539L14.626 15.6339C14.3477 15.3556 14.3477 14.9045 14.626 14.6262C14.9042 14.348 15.3554 14.348 15.6336 14.6262L19.0536 18.0462ZM8.2898 15.8425C4.11867 15.8425 0.737305 12.4612 0.737305 8.29005C0.737305 4.11892 4.11867 0.737549 8.2898 0.737549C12.4609 0.737549 15.8423 4.11892 15.8423 8.29005C15.8423 12.4612 12.4609 15.8425 8.2898 15.8425ZM8.2898 14.4175C11.6739 14.4175 14.4173 11.6742 14.4173 8.29005C14.4173 4.90592 11.6739 2.16255 8.2898 2.16255C4.90568 2.16255 2.1623 4.90592 2.1623 8.29005C2.1623 11.6742 4.90568 14.4175 8.2898 14.4175ZM4.7748 7.72005C4.7748 7.98238 4.56214 8.19505 4.2998 8.19505C4.03747 8.19505 3.8248 7.98238 3.8248 7.72005C3.8248 5.5689 5.56866 3.82505 7.7198 3.82505C7.98214 3.82505 8.1948 4.03771 8.1948 4.30005C8.1948 4.56238 7.98214 4.77505 7.7198 4.77505C6.09333 4.77505 4.7748 6.09357 4.7748 7.72005Z",
    fill: "blue"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/events-icon.bb834d4981549ceea75a629bb5214667.svg";
export { ForwardRef as ReactComponent };